import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ACTIVATION, LIST_COMMENTAIRE } from "../../Utils/constant";
import ok from "../../assets/images/ok.png";
import { updateOne } from "../../services/service";
import { useStoreApp } from "../../store/storeApp";
import { SubmitButton } from "../Widget/SubmitButton";
export const ActivationEnLigne = ({ numeroTicket }) => {
  const [statusOk, setStatusOk] = useState("");
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);

  const commentaire = useStoreApp();
  useEffect(() => {
    commentaire.getData(LIST_COMMENTAIRE, { page: 0, param: "", size: 10 }, "");
  }, []);
  const submit = (data) => {
    const requestData = {
      ...data,
      status: "REALISER",
      numeroTicket: numeroTicket,
    };
    setIsSubmit(true);
    updateOne(ACTIVATION, "", requestData)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Rendez-vous de survey éffectuée");
          setIsSubmit(null);
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err?.response?.data?.donnee);
      });
  };

  return (
    <>
      {isSubmit !== null ? (
        <form
          className="shadow-sm border rounded w-fit lg:w-full p-8"
          onSubmit={handleSubmit(submit)}
        >
          <h1 class="text-amber-500 font-mtn text-2xl font-semibold tracking-tight">
            Activation de la ligne
          </h1>
          <div className="my-4 space-y-4">
            <div className="my-2">
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text text-sm">
                    Resultat de l'activation
                  </span>
                </div>
                <select
                  {...register("resultat", { required: true })}
                  className="select select-bordered w-full"
                  onChange={(e) => {
                    setStatusOk(e.target.value);
                  }}
                >
                  <option disabled selected>
                    Selectionnez un status
                  </option>
                  <option value={"OK"}>OK</option>
                  <option value={"NON_OK"}>Non OK</option>
                  <option value={"PARTIALY_OK"}>Partialy OK</option>
                </select>
              </label>
            </div>

            <div className="my-2">
              <label className="form-control w-full">
                <div className="label -mb-1">
                  <span className="label-text font-medium">
                    Type commentaire
                  </span>
                </div>
                <select
                  {...register("typeCommentaire", { required: true })}
                  className="select select-bordered w-full h-10"
                >
                  <option disabled selected>
                    Selectionnez un type
                  </option>
                  {commentaire?.data?.data?.map((item) => (
                    <option value={item.id}>{item.designation}</option>
                  ))}
                </select>
              </label>
            </div>

            <div className="my-2">
              <label htmlFor="" className="text-sm">
                Commentaire
              </label>
              <textarea
                {...register("commentaire")}
                placeholder="Votre commentaire"
                className="textarea textarea-bordered textarea-sm w-full"
              ></textarea>
            </div>
            <div className="w-full">
              <SubmitButton isSubmit={isSubmit} label={"Enregistrer"} />
            </div>
          </div>
        </form>
      ) : (
        <div className="flex justify-center my-28 w-full">
          <div className="text-center">
            <img className="mx-auto" src={ok} height={80} width={80} alt="" />
            <p className="font-light mt-2  text-sm">
              Activation de la ligne effectuée
            </p>
          </div>
        </div>
      )}

      <div className="w-full mt-4">
        <hr />
        <div
          className="flex mt-4"
          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
        >
          <Box sx={{ flex: "1 1 auto" }} />
          <button
            disabled={isSubmit !== null ? true : false}
            className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
            onClick={() => {
              window.history.back();
              localStorage.removeItem("numeroTicket");
            }}
          >
            Terminer
          </button>
        </div>
      </div>
    </>
  );
};
